<script>
	import { salutationTypes } from "../config";
	import { handleNameChange } from "../helpers";

	import { AddressAutoComplete } from "./AddressAutoComplete";
	import AdvancedTelInput from "./AdvancedTelInput.svelte";
	import EmailInput from "./EmailInput.svelte";
	import Select from "./Select.svelte";
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";

	export let isRegistrationUpdate = false;
	export let required = false;
	export let disabled = false;
	export let idPrefix = "a" + uuid4().substring(0, 3);
	export let title;
	export let firstName;
	export let surname;
	export let dateOfBirth;
	export let email = null;
	export let phone = null;
	export let address = null;

	let phoneInputOptions = {
		defaultCountry: "AU",
		format: "national",
		placeholder: "Enter your phone number",
		invalidateOnCountryChange: false
	};
</script>

<FormRow>
	<!-- <FormColumn cols="2">
		<label for="{idPrefix}_title">Salutation</label>
		<Select
			disabled={disabled || isRegistrationUpdate}
			id="{idPrefix}_title"
			bind:value={title}
			optionList={salutationTypes}
			textProperty="name"
			valueProperty="name"></Select>
	</FormColumn> -->
	<FormColumn cols="6">
		<label for="{idPrefix}_firstName" class:isrequired={required}>First Name</label>
		<input
			{required}
			disabled={disabled || isRegistrationUpdate}
			type="text"
			bind:value={firstName}
			id="{idPrefix}_firstName"
			class="form-control"
			on:change={() => (firstName = handleNameChange(firstName))} />
	</FormColumn>
	<FormColumn cols="6">
		<label for="{idPrefix}_surname" class:isrequired={required}>Surname</label>
		<input
			{required}
			disabled={disabled || isRegistrationUpdate}
			type="text"
			bind:value={surname}
			id="{idPrefix}_surname"
			class="form-control"
			on:change={() => (surname = handleNameChange(surname))} />
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn cols="6">
		<EmailInput label="Email address" {required} {disabled} bind:email id="{idPrefix}_email" />
	</FormColumn>
	<FormColumn cols="6">
		<AdvancedTelInput
			label="Phone number"
			{required}
			{disabled}
			bind:phone
			options={phoneInputOptions}
			id="{idPrefix}_phone" />
	</FormColumn>
</FormRow>

<AddressAutoComplete index={idPrefix} bind:address {disabled} {required} />
